import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delay = 300): T {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timeout = window.setTimeout(() => setDebounced(value), delay)

        return () => {
            window.clearTimeout(timeout)
        }
    }, [value, delay])

    return debounced
}
